<template>
  <div>
    <slot
      name="menu"
      v-bind="{
        showCategory,
        checkAll,
        uncheckAll,
        isSelected,
        isSelectedAll,
        isSelectedNothing,
        showFiltersOnMobile,
        switchFilters
      }"
    ></slot>
    <slot name="projects" v-bind="{ showProject }"></slot>
  </div>
</template>
<script>
import $ from 'cash-dom'

export default {
  props: {
    defaultCategory: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      categories: [],
      showFiltersOnMobile: false
    }
  },
  mounted() {
    if (this.defaultCategory) {
      this.showCategory(this.defaultCategory)
    } else {
      this.checkAll()
    }
  },
  methods: {
    showProject(cats) {
      const values = Object.values(cats)
      const intersect = this.categories.filter((value) =>
        values.includes(value)
      )
      return intersect.length > 0
    },
    showCategory(id) {
      // je tam, smazeme
      if (this.categories.includes(id)) {
        this.categories = this.categories.filter((element) => element !== id)
      } else {
        // neni tam pridame
        this.categories.push(id)
      }

      this.debug()
    },
    checkAll() {
      const cats = $('.ProjectMenu__Right > span')

      this.categories = []
      //this.categories.push("*");
      cats.each((index, el) => {
        this.categories.push(parseInt(el.getAttribute('data-id')))
      })

      this.debug()
    },
    uncheckAll() {
      this.categories = []
      this.debug()
    },
    isSelected(id) {
      return this.categories.includes(id)
    },
    isSelectedAll() {
      return this.categories.length === $('.ProjectMenu__Right > span').length
    },
    isSelectedNothing() {
      return this.categories.length === 0
    },
    switchFilters(event) {
      this.debug(event)
      this.showFiltersOnMobile = !this.showFiltersOnMobile
    },
    debug() {
      // console.log(this.categories);
    }
  }
}
</script>

<style lang="scss"></style>
